"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_dom_1 = __importDefault(require("react-dom"));

var classnames_1 = __importDefault(require("classnames"));

var __1 = require("../..");

var sz_shape_svg_1 = __importDefault(require("./sz_shape.svg"));

require("./SzHelper.scss");

var SzButton_1 = __importDefault(require("../SzButton/SzButton"));

var react_spring_1 = require("react-spring");

var defaultContext = {
  isBackgroundDisplayed: false,
  setIsBackgroundDisplayed: function setIsBackgroundDisplayed() {},
  isHelperDisplayed: false,
  setIsHelperDisplayed: function setIsHelperDisplayed() {},
  DisplayBackground: function DisplayBackground() {
    return new Promise(function () {});
  },
  DisplayHelper: function DisplayHelper() {
    return new Promise(function () {});
  }
};
var HelperContext = react_1.createContext(defaultContext);

var Helper = function Helper(props) {
  var className = props.className,
      title = props.title,
      children = props.children;
  var helperClasses = classnames_1.default('sz-helper rounded-lg shadow-sm p-4', className);
  var headerClasses = classnames_1.default("m-0 pt-2 pb-3 px-md-4 mx-md-4 px-3");
  var contentClasses = classnames_1.default('sz-content-container px-md-4 mx-md-4 px-3');
  return react_1.default.createElement("div", {
    className: helperClasses
  }, title && react_1.default.createElement(__1.SzTypographie, {
    className: headerClasses,
    align: "center",
    variant: "body",
    weight: "bold"
  }, title), react_1.default.createElement("span", {
    className: "sz-circle"
  }, react_1.default.createElement(__1.SzBox, {
    className: "sz-icon-container"
  }, react_1.default.createElement(__1.SzIcon, {
    variant: "line",
    icon: "messages-bubble-question",
    className: "sz-icon"
  }))), react_1.default.createElement(__1.SzBox, {
    className: contentClasses
  }, children), react_1.default.createElement(__1.SzBox, {
    className: "sz-banner-img d-none d-md-block"
  }, react_1.default.createElement(__1.SzBox, {
    className: "sz-img-container"
  }, react_1.default.createElement("img", {
    alt: "logo",
    src: sz_shape_svg_1.default,
    style: {
      height: '386px'
    }
  }))));
};

var AnimatedHelper = function AnimatedHelper(props) {
  var _a = react_1.useContext(HelperContext),
      isHelperDisplayed = _a.isHelperDisplayed,
      DisplayHelper = _a.DisplayHelper,
      setIsHelperDisplayed = _a.setIsHelperDisplayed,
      setIsBackgroundDisplayed = _a.setIsBackgroundDisplayed;

  var className = props.className,
      title = props.title,
      children = props.children;

  var _b = __read(react_spring_1.useSpring(function () {
    return {
      from: {
        opacity: 0
      },
      to: {
        opacity: 1
      },
      reverse: !isHelperDisplayed,
      config: {
        duration: 300
      },
      onRest: function onRest() {
        if (!isHelperDisplayed) {
          setIsBackgroundDisplayed(false);
        }
      }
    };
  }, [isHelperDisplayed]), 1),
      styles = _b[0];

  var onClose = function onClose() {
    DisplayHelper().then(function (value) {
      if (value === 'hiding') {
        setIsHelperDisplayed(false);
      }
    });
  };

  var helperClasses = classnames_1.default('sz-helper container pt-2 px-4 pb-4 rounded-lg shadow-sm text-right', className);
  var headerClasses = classnames_1.default("m-0 pt-2 pb-3 px-md-4 mx-md-4 px-3");
  var contentClasses = classnames_1.default('sz-content-container px-md-4 mx-md-4 px-3');
  return react_1.default.createElement(react_spring_1.animated.div, {
    style: styles,
    className: helperClasses
  }, react_1.default.createElement(SzButton_1.default, {
    icon: "close",
    variant: "tertiary",
    onClick: onClose
  }), title && react_1.default.createElement(__1.SzTypographie, {
    className: headerClasses,
    align: "center",
    variant: "body",
    weight: "bold"
  }, title), react_1.default.createElement("span", {
    className: "sz-circle"
  }, react_1.default.createElement(__1.SzBox, {
    className: "sz-icon-container"
  }, react_1.default.createElement(__1.SzIcon, {
    variant: "line",
    icon: "messages-bubble-question",
    className: "sz-icon"
  }))), react_1.default.createElement(__1.SzBox, {
    className: contentClasses
  }, children), react_1.default.createElement(__1.SzBox, {
    className: "sz-banner-img d-none d-md-block"
  }, react_1.default.createElement(__1.SzBox, {
    className: "sz-img-container"
  }, react_1.default.createElement("img", {
    alt: "logo",
    src: sz_shape_svg_1.default,
    style: {
      height: '386px'
    }
  }))));
};

var PortalHelper = function PortalHelper(props) {
  var _a = react_1.useContext(HelperContext),
      btnRef = _a.btnRef,
      isBackgroundDisplayed = _a.isBackgroundDisplayed,
      setIsHelperDisplayed = _a.setIsHelperDisplayed,
      DisplayHelper = _a.DisplayHelper;

  var _b = __read(react_1.useState(new DOMRect()), 2),
      positions = _b[0],
      setPositions = _b[1];

  var wrapper = react_1.useRef(document.createElement('div'));
  var innerHeight = window.innerHeight,
      innerWidth = window.innerWidth,
      scrollY = window.scrollY,
      scrollX = window.scrollX;
  var defaultBottom = innerHeight - positions.bottom;
  var defaultRight = innerWidth - positions.right;
  var bottom = (scrollY > 0 ? defaultBottom - scrollY : defaultBottom) + "px";
  var right = (scrollX > 0 ? defaultRight - scrollX : defaultRight) + "px";
  var animation = {
    from: {
      backgroundColor: 'rgba(102, 73, 0, 0)',
      top: positions.top + "px",
      left: positions.left + "px",
      bottom: bottom,
      right: right
    },
    to: {
      backgroundColor: 'rgba(102, 73, 0, 0.8)',
      top: '-300px',
      bottom: '-300px',
      left: '-300px',
      right: '-300px'
    },
    config: {
      duration: 300
    },
    reverse: !isBackgroundDisplayed
  };

  var _c = __read(react_spring_1.useSpring(function () {
    return __assign(__assign({}, animation), {
      reset: isBackgroundDisplayed,
      onStart: function onStart() {
        if (isBackgroundDisplayed) {
          wrapper.current.className = 'sz-helper-wrapper active';
        }
      },
      onRest: function onRest() {
        if (isBackgroundDisplayed) {
          DisplayHelper().then(function (value) {
            if (value === 'displaying') {
              setIsHelperDisplayed(true);
            }
          });
        }

        if (!isBackgroundDisplayed) {
          wrapper.current.className = 'sz-helper-wrapper inactive';
        }
      }
    });
  }, [isBackgroundDisplayed]), 1),
      styles = _c[0];

  react_1.useEffect(function () {
    var currentWrapper = wrapper.current;
    currentWrapper.className = 'sz-helper-wrapper inactive';
    document.body.append(currentWrapper);
    return function () {
      currentWrapper.remove();
    };
  }, []);
  react_1.useEffect(function () {
    if (btnRef.current) {
      setPositions(btnRef.current.getBoundingClientRect());
    }
  }, [btnRef, scrollY]);
  return react_dom_1.default.createPortal(react_1.default.createElement(react_spring_1.animated.div, {
    style: __assign({
      position: 'absolute',
      borderRadius: '50%',
      overflow: 'hidden',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }, styles)
  }, react_1.default.createElement(AnimatedHelper, __assign({}, props))), wrapper.current);
};

var SzHelper = function SzHelper(props) {
  var _a = props.type,
      type = _a === void 0 ? 'normal' : _a,
      btnStyles = props.btnStyles,
      _b = props.cancelPulse,
      cancelPulse = _b === void 0 ? false : _b;

  var _c = __read(react_1.useState(false), 2),
      isBackgroundDisplayed = _c[0],
      setIsBackgroundDisplayed = _c[1];

  var _d = __read(react_1.useState(false), 2),
      isHelperDisplayed = _d[0],
      setIsHelperDisplayed = _d[1];

  var btnRef = react_1.useRef(null);

  var _e = __read(react_1.useState(cancelPulse), 2),
      isClicked = _e[0],
      setIsClicked = _e[1];

  var onClick = function onClick() {
    if (!isClicked) {
      setIsClicked(true);
    }

    DisplayBackground().then(function (value) {
      if (value === 'displaying') {
        setIsBackgroundDisplayed(true);
      } else {
        setIsBackgroundDisplayed(false);
      }
    });
  };

  var DisplayBackground = function DisplayBackground() {
    return new Promise(function (resolve) {
      if (isBackgroundDisplayed) {
        resolve('hiding');
      } else {
        resolve('displaying');
      }
    });
  };

  var DisplayHelper = function DisplayHelper() {
    return new Promise(function (resolve) {
      if (isHelperDisplayed) {
        resolve('hiding');
      } else {
        resolve('displaying');
      }
    });
  };

  if (type !== 'normal') {
    return react_1.default.createElement(HelperContext.Provider, {
      value: {
        type: type,
        btnRef: btnRef,
        DisplayBackground: DisplayBackground,
        DisplayHelper: DisplayHelper,
        isBackgroundDisplayed: isBackgroundDisplayed,
        setIsBackgroundDisplayed: setIsBackgroundDisplayed,
        isHelperDisplayed: isHelperDisplayed,
        setIsHelperDisplayed: setIsHelperDisplayed
      }
    }, react_1.default.createElement(SzHelperButton, {
      onClick: onClick,
      isClicked: isClicked,
      cancelPulse: cancelPulse,
      btnStyles: btnStyles
    }), react_1.default.createElement(PortalHelper, __assign({}, props)));
  }

  return react_1.default.createElement(Helper, __assign({}, props));
};

var SzHelperButton = function SzHelperButton(props) {
  var _a = react_1.useContext(HelperContext),
      type = _a.type,
      btnRef = _a.btnRef;

  var btnStyles = props.btnStyles,
      isClicked = props.isClicked,
      onClick = props.onClick;
  var defaultStyles = {
    bottom: '5vh',
    right: '5vw',
    position: 'fixed'
  };

  var _b = __read(react_spring_1.useSpring(function () {
    return {
      loop: {
        reverse: true
      },
      config: __assign(__assign({}, react_spring_1.config.molasses), {
        duration: 1000
      }),
      cancel: isClicked,
      reset: isClicked,
      delay: 500,
      from: {
        boxShadow: '0px 0px 0px 0px rgb(255 236 190)'
      },
      to: {
        boxShadow: '0px 0px 15px 12px rgb(255 236 190)'
      }
    };
  }, [isClicked]), 1),
      styles = _b[0];

  if (type === 'floating-btn') {
    return react_1.default.createElement(react_spring_1.animated.button, {
      style: __assign(__assign({}, btnStyles || defaultStyles), styles),
      ref: btnRef,
      className: "sz-helper-float-btn rounded-circle d-flex justify-content-center align-items-center",
      onClick: onClick
    }, react_1.default.createElement(__1.SzIcon, {
      variant: "line",
      icon: "messages-bubble-question",
      className: "text-white"
    }));
  }

  return react_1.default.createElement("button", {
    className: "sz-helper-btn d-flex align-items-center justify-content-center",
    onClick: onClick,
    ref: btnRef
  }, react_1.default.createElement(__1.SzTypographie, {
    tag: "span",
    weight: "medium",
    className: "pr-2"
  }, "En savoir plus"), react_1.default.createElement(__1.SzIcon, {
    variant: "line",
    icon: "messages-bubble-question",
    className: "text-yelow"
  }));
};

exports.default = SzHelper;